import React, { Fragment } from "react";
import { PagedDataView } from "../../../../components/lists/PagedDataView/PagedDataView";
import { api, Report, ReportSection, IReportRun } from "../../../../logic/api";
import propTypes from "prop-types";
import { renderHeader, renderItem } from "../../helpers/renderers";
import { useTranslation } from "react-i18next";

interface IReportViewTableProps {
    report: Report;
    section: ReportSection;
    values?: unknown | null;
}

const ReportViewTable: React.FunctionComponent<IReportViewTableProps> = ({
    report,
    section,
    values,
}) => {
    if (report == null || (report.query || "").length == 0) {
        return <Fragment></Fragment>
    }

    const { t } = useTranslation();

    return <div style={{ backgroundColor: "white", display: "inline-block" }}>
        <PagedDataView<IReportRun, unknown>
            apiHook={api.hooks.reports.run}
            parameters={{
                id: report.id,
                section: section,
                values: values,
            }}
            animate={false}
            maintainRecordsAfterParamChange={true}
            isTable={true}
            showError={true}
            header={renderHeader}
            renderItem={renderItem}
        >
            <div>
                {t("reports.noData")}
            </div>
        </PagedDataView>
    </div>;
}

ReportViewTable.propTypes = {
    report: propTypes.any
}
export default ReportViewTable;
